import BaseRequest from './BaseRequest';

const schema = 'lucky-game';

class LuckyGameRequest extends BaseRequest {
  fetchConfig() {
    const url = `${schema}/config`;
    return this.get(url);
  }
}

export default LuckyGameRequest;
